import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/dream-energy/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1223}
              height={863}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#75CB4C" }}>Solution</span>
            </h2>
            <p>
              Our expert development team at Tekrevol took it upon themselves to
              create a website that’s easy to navigate, user-friendly and
              includes the custom functionality that allow users to compare
              plans with respect to their utility needs and size of business.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
